import styled from 'styled-components';
import { InputType, inputStyle } from '@westwing/ui-kit/Theme/inputs';

const TextInput = styled.input<{ inputType: InputType }>`
    background-color: transparent;
    width: 100%;
    margin: auto;
    padding: 0 10px;
    -webkit-appearance: none;
    border: 1px solid ${({ theme }) => theme.colors.charcoal20};
    ${({ inputType }) => inputStyle(inputType)}
    &:disabled {
        background: ${({ theme }) => theme.colors.charcoal2};
        color: ${({ theme }) => theme.colors.charcoal100};
        opacity: 1;
    }
`;

export default TextInput;
